import React from 'react'

import EditSubTypeForm from '../../modules/SubType/components/EditSubTypeForm'
export default function EditSubTypePage() {
  return <EditSubTypeForm />
}
